// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import styled from 'styled-components';

const ValidationError = styled.span`
  color: #f00;
`;

type Props = {
  title: string;
  onChange: (event: { target: { value: string } }) => void;
  value?: number | string;
  placeholder?: string;
  type?: string;
  min?: number;
  max?: number;
  style?: unknown;
  disabled?: boolean;
};

const GroupedFormField = ({
  title,
  placeholder,
  onChange,
  value = '',
  type,
  min = 0,
  max = 9999,
  style,
  disabled = false,
}: Props) => (
  <FormGroup style={style}>
    <ControlLabel>{title}</ControlLabel>
    <FormControl
      type={type || 'text'}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      disabled={disabled}
    />
    {type === 'number' && !!value && (+value < min || +value > max) && (
      <ValidationError>
        Number should be in range between {min} and {max}
      </ValidationError>
    )}
    {!!value &&
      (value.toString().length < min ||
        (value.toString().length > max && (
          <ValidationError>
            Length should not exceed {max} characters
          </ValidationError>
        )))}
  </FormGroup>
);

export default GroupedFormField;
